export default "__VITE_ASSET__ba4ddb88__"